import SwivuModal from "../../../react/components/editors/SwivuModal.jsx";
import { useCallback } from "react";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import TimelineConfiguratorTimescalesTab from "./TimelineConfiguratorTimescalesTab.jsx";
import TimelineConfiguratorNonWorkingDaysTab from "./TimelineConfiguratorNonWorkingDaysTab.jsx";
import TimelineConfiguratorSettingsTab from "./TimelineConfiguratorSettingsTab.jsx";
import EditorBase from "../base/EditorBase.jsx";
import { getScheduleInstanceFromViewManager } from "../../../other/utils/otherUtils.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { SETTING_TAB_WIDGET_KEYS } from "../../../other/constants/OtherKeys.jsx";

const SWIVU_PERSONAL_SETTING_BUTTON_ID = 'swivu-open-personal-setting-editor';
class SwivuTimelineConfiguratorEditor extends EditorBase {
  static get $name() {
    return 'SwivuTimelineConfiguratorEditor';
  }

  static get type() {
    return WIDGET_KEYS.swivuTimelineConfiguratorPopup;
  }

  static get configurable() {
    return {
      title: "Timeline Configurator",
      minWidth: "30em",
      maxWidth: "100vw",
      width: "60em",
      closable: true,
      autoClose: false,
      draggable: true,
      cls: "resize swivu-finder minimal-gradient-editor",
      stateId: PERSISTENCE_STATE_KEYS.timelineConfiguratorEditor,
      minHeight: "635px",
      maxHeight: "100vh",
      height: "min(100vh, 800px)",
      header:{
        cls: 'h-[50px]',
      },
      layoutStyle: {
        flexDirection: "column",
        flexWrap: "nowrap"
      },
      items: {
        explainerButton: {
          type: "button",
          cls: "text-[#616161] dark:text-[#c0c1c2] py-2 border-0 border-l-4 border-solid border-[#e0e0e0] dark:border-[#333] pl-[6px] bg-transparent leading-none justify-start min-h-[auto] whitespace-normal text-left",
          onClick: 'up.onExplainerButtonClick',
          html: `<div><span class='text-[#e6994c]'>
          Adjustments in this modal are included in saved views.
          </span> For general timeline settings, <span class='text-[#4c99e6]' id='${SWIVU_PERSONAL_SETTING_BUTTON_ID}'> navigate to personal settings.</span></div>`
        },
        tabs: {
          type: WIDGET_KEYS.swivuTabPanel,
          cls: "h-full",
          stateId: "swivu-timeline-configurator-editor",
          items: {
            timescalesTab : { type: TimelineConfiguratorTimescalesTab.type },
            nonWorkingDaysTab: { type: TimelineConfiguratorNonWorkingDaysTab.type},
            settingsTab: { type: TimelineConfiguratorSettingsTab.type},
          },
          listeners: {
            beforeTabChange: "up.beforeTabChangeHandler"
          }
        }
      },
      bbar: {
        hidden: true,
        items: {
          doneButton: {
            type: "button",
            icon: "fa-light fa-close",
            text: "Done",
            cls: 'bg-[transparent] text-[#3884e1] border-[1.5px] !rounded-md',
            onClick: "up.close",
          },
        }
      }
    }
  }

  editRecord(record, context, otherParams) {
    this.context = context;
    if (!context.viewManager.pageViewsRef || !getScheduleInstanceFromViewManager(context.viewManager)) {
      this.hide();
      return;
    }
    this.changeCrossToEsc();
    super.editRecord(record, context, otherParams);

    this.eachWidget((w) => {
      if (w.isTimelineConfiguratorTabBase) {
        w.loadRecord(record, context, { ...otherParams, editor: this });
      }
    });

    this.widgetMap.tabs.load(record, context, otherParams);
  }

  beforeTabChangeHandler() {
    this.bbar.hidden = true;
  }

  onExplainerButtonClick({ event }) {
    if (event.target.id === SWIVU_PERSONAL_SETTING_BUTTON_ID) {
      this.context.editorHandler.openEditor(
        EDITOR_KEYS.settingPersonalEditor,
        null,
        { selectTabByTypeOnOpen: SETTING_TAB_WIDGET_KEYS.personalSchedularTab },
        { useExisting: true, by: "recordType" }
      );
    }
  }
}

SwivuTimelineConfiguratorEditor.initClass();

const SwivuTimelineConfiguratorEditorPopup = ({ context, record, onClose, isShow, editorInstance }) => {

  const {selectTabByTypeOnOpen} = record || {};

  const onShowHandler = useCallback((editor, otherParams= {}) => {
    editor.project = context.project;
    editor.editRecord(record, context, Object.assign(otherParams, {selectTabByTypeOnOpen}));
    editorInstance.editorRef = editor;
  }, [context, editorInstance, record]);

  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.swivuTimelineConfiguratorPopup}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  )
}

export default SwivuTimelineConfiguratorEditorPopup;
